import React from 'react';
import './contact.scss';
import { TitleComponent } from '../../components/TitleDocument';
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import { Icon, divIcon, point } from "leaflet";

// create custom icon
const customIcon = new Icon({
  // iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
  iconUrl: require("../../assets/map.png"),
  iconSize: [38, 38] // size of the icon
});

// custom cluster icon
const createClusterCustomIcon = function (cluster) {
  return new divIcon({
    html: `<span class="cluster-icon">${cluster.getChildCount()}</span>`,
    className: "custom-marker-cluster",
    iconSize: point(33, 33, true)
  });
};
const Contact = () => {
  const position = [21.01982433413347, 105.77927203009259];
  return (
    <section className='contacts'>
        <TitleComponent title='Contact'/>
        <div className='container'>
            <div className='content'>
                <span>tổng công ty hạ tầng mạng</span>
                <p>Địa chỉ: Số 30, đường Phạm Hùng, phường Mỹ Đình 1, quận Nam Từ Liêm, Hà Nội<br/>
                Điện thoại: +84-437877777<br/>
                Fax: +84-437876600<br/>
                Email:<i>vnptnet@vnpt.com</i></p>
            </div>
        </div>
        <MapContainer center={position} zoom={13} >
    
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <MarkerClusterGroup
            chunkedLoading
            iconCreateFunction={createClusterCustomIcon}
          >
      
              <Marker position={position} icon={customIcon}>
                <Popup>VNPT_Net</Popup>
              </Marker>
        

          </MarkerClusterGroup>
        </MapContainer>
      
    </section>
    
    
  )
}

export default Contact
